import { useRouter } from 'next/router';
export function useRecordId() {
    const router = useRouter();
    const { recordId } = router.query;
    return recordId;
}
